import { formatCurrency } from "@scandotcom/react";
import * as React from "react";

import { StarRating } from "../shared/StarRating";
import { ScanningLocation } from "../types/scan/ScanningLocation";

interface Props {
  location: ScanningLocation;
}

export const LocationPopupContent: React.FC<Props> = ({ location }) => {
  return (
    <div className="space-y-4 md:min-w-[300px]">
      {location.thumbnail_image ? (
        <div className="max-h-48 overflow-hidden rounded-2xl">
          <img
            src={location.thumbnail_image}
            className="h-full w-full object-cover"
          />
        </div>
      ) : null}
      <h3 className="display-xl">{location.name}</h3>
      {location.rating > 0 ? (
        <div className="flex items-center gap-2 text-sm">
          <div>
            <StarRating rating={location.rating} />
          </div>
          <span className="font-semibold">
            {Intl.NumberFormat(undefined, {
              minimumFractionDigits: 1,
            }).format(location.rating)}
          </span>
          <span className="text-neutral-500 underline">
            ({location.review_count} review
            {location.review_count > 1 ? "s" : ""})
          </span>
        </div>
      ) : null}
      <div className="text-sm text-neutral-600">
        {[location.address, location.town, location.county]
          .filter((value) => !!value)
          .join(", ")}
      </div>
      <div className="flex gap-2">
        <div className="mr-auto">
          {location.from_price ? (
            <>
              <div className="display-xl">
                {formatCurrency(location.from_price / 100, {
                  maximumFractionDigits: 0,
                })}
              </div>
              <div className="text-sm text-neutral-500">Starting from</div>
            </>
          ) : null}
        </div>
        <a
          href={`/locations/${location.slug}`}
          className="button button-primary text-sm"
          target="_blank"
        >
          View profile
        </a>
      </div>
    </div>
  );
};
